@if (editable) {
  <tag-input
    [(ngModel)]="items"
    [placeholder]="placeholder"
    [secondaryPlaceholder]="placeholder"
    [hideForm]="hideForm"
    [addOnBlur]="true"
    [editable]="editableTag"
    (onTagEdited)="onTagEdited($event)"
    (ngModelChange)="emitValue()"
  >
  </tag-input>
} @else {
  <tag-input
    [hideForm]="true"
    [(ngModel)]="items"
  >
  </tag-input>
}
